import React, { useContext, useEffect, useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
//import UsersApi from "./API/UsersApi";
import StringIntReq from '../../Requests/StringIntReq';
import { UserContext } from '../../App';
import UsersApi from '../../API/UsersApi';
import Swal from 'sweetalert2';




const TermsModal = () => {
  const currentUser = useContext(UserContext);
  const [open, setOpen] = useState(false);
  
  
  

  useEffect(() => {
  
    if (!currentUser.isConsentGiven) {
      setOpen(true); // Show dialog if not accepted
    }
  }, []);

  const handleAccept = async () => {
  const req = new StringIntReq();
  req.int=currentUser.id;
    Swal.fire({
      icon: "info",
      title: "Please Wait",
      text: "Saving Consent",
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      showCancelButton: false,
     
      willOpen: () => {
          Swal.showLoading();
      },
  })

    req.bool=true;
    let res = await UsersApi.ConfirmOnTermsAndCondition(req);
  
      if(res?.status?.success){
        Swal.fire({
          icon:"success",
          title:"Success",
          text:"Consent Saved successfully",
          didOpen: () => {
            Swal.hideLoading();
        },
        })
        window.location.reload();
      }else{
        Swal.fire({
          icon:"error",
          title:"Failed",
          text:"Failed to Save Consent ",
          didOpen: () => {
            Swal.hideLoading();
        },
        })
      }
   
    setOpen(false); // Close the dialog
  };

  const handleCancel = () => {
    setOpen(false);
  
  };

  return (
    <Dialog open={open} onClose={handleCancel}  
    scroll="paper" // Enables scrolling within the content
    maxWidth="sm" // Adjust the dialog size
    fullWidth // Makes it take the full width within the maxWidth
    >
      <DialogTitle>Terms and Conditions for Live Tracking Usage </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" paragraph>
        <strong> Effective Date</strong>: April 05, 2025
        </Typography>
        <Typography variant="body2" paragraph>
        These Terms and Conditions ("Terms") govern the use of live tracking features within Lightning OS ("the Application").
         By using the live tracking feature,
         you ("the User") agree to comply with these Terms.
        </Typography>
        <Typography variant="body2" paragraph>
          <strong>1. Purpose of Live Tracking</strong>
          <br />
          The live tracking feature is designed to enhance operational efficiency by monitoring the location of sales representatives in real-time.
           It ensures transparency, improves logistics, and supports effective decision-making for assigned tasks.
        </Typography>
        <Typography variant="body2" paragraph>
          <strong>2. Consent to Location Tracking</strong>
          <br />
          By enabling and using the live tracking feature, you consent to the Application collecting, storing, and processing your location data.
          <ul>
            <li>
              <strong>Active Use:</strong> Location tracking is only active when the Application is running and logged into your account.
            </li>
            <li>
              <strong>Transparency:</strong> You will be notified when tracking begins.
            </li>
          </ul>
        </Typography>
        <Typography variant="body2" paragraph>
          <strong>3. Data Privacy and Security</strong>
          <br />
          We value your privacy and are committed to protecting your personal information.
          <ul>
            <li>
              <strong>Usage of Data:</strong>Collected location data will only be used for purposes outlined in this agreement and as detailed in our Privacy Policy.
            </li>
            <li>
              <strong>Data Storage:</strong> Location data will be stored securely and retained only for the duration required to fulfill operational purposes or comply with legal obligations.
            </li>
            <li>
              <strong>Sharing of Data:</strong> Your location information will not be shared with unauthorized third parties without your explicit consent, except as required by law.
            </li>
          </ul>
        </Typography>
        <Typography variant="body2" paragraph>
          <strong>4. User Responsibilities</strong>
          <br />
          <ul>
            <li>
              <strong>Accurate Information:</strong> You agree to provide accurate information when using the Application and ensure location services on your device are enabled.
            </li>
            <li>
              <strong>Prohibited Activities:</strong> You shall not use the live tracking feature
              for any unauthorized, unlawful, or malicious activities.
            </li>
            <li>
              <strong>Device Management:</strong> Ensure that the device used for live tracking
              has sufficient battery and connectivity to enable accurate tracking.
            </li>
          </ul>
        </Typography>
        <Typography variant="body2" paragraph>
          <strong>5. Contractor Responsibilities</strong>
          <br />
          Lightning OS, LLC commits to the ethical use of live tracking data and acknowledges its responsibility to:
           <ol style={{ listStyleType: "decimal", marginLeft: "20px" }}>
                <li>Ensure transparency in tracking practices.</li>
            <li>Notify Users of the scope and limitations of live tracking.</li>
            <li>
              Provide mechanisms for addressing queries or grievances related to live tracking.
            </li>
          </ol>
        </Typography>
        <Typography variant="body2" paragraph>
          <strong>6. Opting Out of Live Tracking</strong>
          <br />
          You may opt out of live tracking by submitting a written request. Note that opting out may affect your ability to perform certain job functions or comply with company policies..
        </Typography>
        <Typography variant="body2" paragraph>
          <strong>7. Limitations of Liability</strong>
          <br />
          Lightning OS, LLC will not be liable for:
          <ol style={{ listStyleType: "decimal", marginLeft: "20px" }}>
            <li>
              Any inaccuracies in location data due to device malfunction, network issues, or
              incorrect usage.
            </li>
            <li>
              Unauthorized access to location data resulting from a User’s negligence.
            </li>
          </ol>
        </Typography>
        <Typography variant="body2" paragraph>
          <strong>8. Changes to the Terms</strong>
          <br />
          Lightning OS, LLC reserves the right to modify these Terms at any time.
          Users will be notified of changes via in-app notification.
          Continued use of the live tracking feature after such modifications constitutes agreement to the revised Terms.
        </Typography>
        <Typography variant="body2" paragraph>
          <strong>9. Contact Information</strong>
          <br />
          if you have questions or concerns regarding these Terms, please contact Shasta Weishampel at: 281.868.9760 or <a type='link' >shasta@lightningos.world </a>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAccept}  style={{ backgroundColor: "#181E4B", color: "white" }} variant="contained">
          Accept
        </Button>
        {/* <Button onClick={handleCancel} color="error" variant="contained">
          Cancel
        </Button> */}
      </DialogActions>
    </Dialog>
  );
};

export default TermsModal;
